  export default class GetElement {
    Indice :string;
    Codu ? :string;
    Motpas?:string;
    Etat:string;
    CodAge :string;

    constructor(Indice:string, Codu:string,MotPas:string,Etat:string,CodAge:string)
    {
     this.Indice=Indice;
     this.Codu=Codu;
     this.Etat=Etat;
     this.CodAge=CodAge;
    }

}